import { Pages } from '.generated/Project.CW.model';
import type { MedicalCondition, WithContext } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';

export const buildConditionPageJsonLd = (
  data: Pages.ConditionOrTreatment,
  pageUrl: string
): WithContext<MedicalCondition> => ({
  '@context': 'https://schema.org',
  '@type': 'MedicalCondition',
  name: data.fields?.Title?.value,
  description: stripHtmlTags(data.fields?.Description?.value),
  url: pageUrl,
});
